// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IsolationUnitEntity } from './IsolationUnitEntity';
import {
  IsolationUnitEntityFromJSON,
  IsolationUnitEntityFromJSONTyped,
  IsolationUnitEntityToJSON,
  IsolationUnitEntityToJSONTyped,
} from './IsolationUnitEntity';

/**
 *
 * @export
 * @interface IsolationUnitList
 */
export interface IsolationUnitList {
  /**
   *
   * @type {Array<IsolationUnitEntity>}
   * @memberof IsolationUnitList
   */
  items?: Array<IsolationUnitEntity>;
}

/**
 * Check if a given object implements the IsolationUnitList interface.
 */
export function instanceOfIsolationUnitList(
  value: object,
): value is IsolationUnitList {
  return true;
}

export function IsolationUnitListFromJSON(json: any): IsolationUnitList {
  return IsolationUnitListFromJSONTyped(json, false);
}

export function IsolationUnitListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(IsolationUnitEntityFromJSON),
  };
}

export function IsolationUnitListToJSON(json: any): IsolationUnitList {
  return IsolationUnitListToJSONTyped(json, false);
}

export function IsolationUnitListToJSONTyped(
  value?: IsolationUnitList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(IsolationUnitEntityToJSON),
  };
}
